import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-8 mb-5" }
const _hoisted_2 = { class: "col-xl-5" }
const _hoisted_3 = { class: "card seq-card mb-5 mb-xxl-8 h-100" }
const _hoisted_4 = { class: "card-header border-0 pt-5" }
const _hoisted_5 = { class: "card-title align-items-center" }
const _hoisted_6 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Current Account", -1)
const _hoisted_8 = { class: "card-body pt-2" }
const _hoisted_9 = { class: "seq-visa" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-between align-items-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "seq-visa__label" }, "Total Balance"),
  /*#__PURE__*/_createVNode("span", { class: "seq-visa__brand" }, "AGG")
], -1)
const _hoisted_11 = { class: "seq-visa__balance" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_13 = { class: "seq-visa__number" }
const _hoisted_14 = { class: "seq-visa__name text-uppercase" }
const _hoisted_15 = { class: "col-xl-7" }
const _hoisted_16 = { class: "row g-5 g-xl-8" }
const _hoisted_17 = { class: "col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_EncashmentProcess = _resolveComponent("EncashmentProcess")
  const _component_EncashmentHistory = _resolveComponent("EncashmentHistory")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h3", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Credit-card.svg" })
              ]),
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.availablebalance).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1),
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.maskedUsid), 1),
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.cardHolder), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_EncashmentProcess, {
          "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8 h-100",
          onLoaded: _ctx.onProcessLoaded
        }, null, 8, ["onLoaded"])
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_EncashmentHistory, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
      ])
    ])
  ], 64))
}